import moment from "moment";
import { I18n } from "react-redux-i18n";

const getFields = () => [
	{
		key: 'date',
		label: 'billingUsage.date',
		fixed: true,
		customCell: (data) => {
			return moment(data.date).format('MMM D, YYYY');
		}
	},
	{
		key: 'transactionType',
		label: 'report.query.transactionType',
	},
	{
		key: 'reference',
		label: 'report.result.referralDetail.reference',
	},
	{
		key: 'status',
		label: 'report.query.referralDetail.Status',
		customCell: (data) => {
			return data?.status ? I18n.t(`billingUsage.${data.status}`) : '';
		}
	},
	{
		key: 'amount',
		label: 'billingUsage.amount',
	},
];

const fields = getFields();

export default fields
